{
	"name": "passporter-light",
	"colors": {
		"basics": {
			"black": "#000000",
			"white": "#FFFFFF"
		},
		"primary": {
			"25": "#EDF8F4",
			"50": "#C8EADE",
			"100": "#90D5BD",
			"200": "#59C09C",
			"300": "#3FA682",
			"400": "#318165",
			"500": "#2A7057",
			"600": "#245F4A",
			"700": "#1E4F3E",
			"800": "#183F32",
			"900": "#15372B"
		},
		"secondary": {
			"25": "#FAF3F1",
			"50": "#F5E7E3",
			"100": "#DCAC9E",
			"200": "#CD8974",
			"300": "#C37158",
			"400": "#BE654A",
			"500": "#B45C41",
			"600": "#9A4F38",
			"700": "#81422E",
			"800": "#673425",
			"900": "#4D271C"
		},
		"tertiary": {
			"25": "#FFFFFF",
			"50": "#F9F9F9",
			"100": "#F5F5F4",
			"200": "#E5E4E2",
			"300": "#D5D3D1",
			"400": "#C6C4C0",
			"500": "#77736C",
			"600": "#66635C",
			"700": "#55524D",
			"800": "#44423E",
			"900": "#33312E"
		},
		"neutral": {
			"25": "#FFFFFF",
			"50": "#F9F9F9",
			"100": "#F5F5F4",
			"200": "#E5E4E2",
			"300": "#D5D3D1",
			"400": "#C6C4C0",
			"500": "#77736C",
			"600": "#66635C",
			"700": "#55524D",
			"800": "#44423E",
			"900": "#33312E"
		},
		"error": {
			"25": "#FFECF1",
			"50": "#FFD8E2",
			"100": "#FFC5D4",
			"200": "#FF789A",
			"300": "#FF3E6E",
			"400": "#F2003C",
			"500": "#DF0038",
			"600": "#BC002F",
			"700": "#AB002B",
			"800": "#9A0027",
			"900": "#78001E"
		},
		"social": {
			"25": "#F2F6FE",
			"50": "#D8E5FD",
			"100": "#BED3FB",
			"200": "#6F9FF7",
			"300": "#4682F4",
			"400": "#3674EB",
			"500": "#0E5BEB",
			"600": "#0C53D5",
			"700": "#0A42AB",
			"800": "#073280",
			"900": "#052155"
		}
	}
}
